import { render, staticRenderFns } from "./indexPC.vue?vue&type=template&id=c8df903a&scoped=true"
import script from "./indexPC.vue?vue&type=script&lang=js"
export * from "./indexPC.vue?vue&type=script&lang=js"
import style0 from "./indexPC.vue?vue&type=style&index=0&id=c8df903a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8df903a",
  null
  
)

export default component.exports